import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var UsersSlash = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 640 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L440.6 320h178.1c11.8 0 21.3-9.6 21.3-21.3 0-58.9-47.8-106.7-106.7-106.7h-42.6c-15.9 0-31 3.5-44.6 9.7 1.3 7.2 1.9 14.7 1.9 22.3 0 30.2-10.5 58-28 79.9l-25.2-19.7c13.3-16.5 21.2-37.4 21.2-60.2 0-53-43-96-96-96-31.1 0-58.7 14.8-76.3 37.7l-40.6-31.8c13-14.2 20.9-33.1 20.9-53.9 0-44.2-35.8-80-80-80-27.7 0-52.1 14.1-66.5 35.5L38.8 5.1zM106.7 192C47.8 192 0 239.8 0 298.7 0 310.4 9.6 320 21.3 320h214.1c-20.6-18.2-35.2-42.8-40.8-70.8L121.8 192h-15.1zm154.6 160C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7h330.6c10.5 0 19.5-6 23.9-14.8L324.9 352h-63.6zM512 160c44.2 0 80-35.8 80-80S556.2 0 512 0s-80 35.8-80 80 35.8 80 80 80z"
  }));
});
UsersSlash.displayName = 'UsersSlash';
export var UsersSlashDimensions = {
  height: 512,
  width: 640
};